import { render } from "./CustomChangeComponentControl.vue?vue&type=template&id=40631df2&ts=true"
import script from "./CustomChangeComponentControl.vue?vue&type=script&lang=ts"
export * from "./CustomChangeComponentControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/workflow/infrastructure/component/rete/customization/CustomChangeComponentControl.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40631df2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40631df2', __exports__)) {
    api.reload('40631df2', __exports__)
  }
  
  module.hot.accept("./CustomChangeComponentControl.vue?vue&type=template&id=40631df2&ts=true", () => {
    api.rerender('40631df2', render)
  })

}


export default __exports__